import { render, staticRenderFns } from "./PermissionDecline.vue?vue&type=template&id=2d22ac5e&scoped=true&"
import script from "./PermissionDecline.vue?vue&type=script&lang=js&"
export * from "./PermissionDecline.vue?vue&type=script&lang=js&"
import style0 from "./PermissionDecline.vue?vue&type=style&index=0&id=2d22ac5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d22ac5e",
  null
  
)

export default component.exports